import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

export const Tabs = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.medium.media} {
            flex-wrap: wrap;
            justify-content: space-evenly;
            margin-top: 1rem;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            gap: 1%;
            row-gap: 0.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            gap: 1.5%;
            row-gap: 1rem;
        }
    `}
`;

interface TabProps {
    $isActive: boolean;
}

export const Tab = styled.button<TabProps>`
    ${({ $isActive, theme }) => css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        cursor: pointer;
        line-height: 1.2;
        padding: 0.5rem;
        background-color: #395b5f;
        color: ${theme.colors.primaryContrast.hex};
        border-radius: 0.5rem;
        transform: translateZ(0);
        border: none;
        width: 100%;

        ${$isActive &&
        css`
            background-color: ${theme.colors.primaryContrast.hex};
            color: #395b5f;
            border: ${theme.commonStyles.brandPixel} solid ${theme.colors.accents[10].hex};
        `}

        ${!$isActive &&
        css`
            :hover {
                text-decoration: none;
                background-color: ${theme.colors.accents[24].hex};
            }
        `}

        @media ${theme.breakpoints.medium.media} {
            padding: 0.75rem 0.5rem;
            width: 49.5%;
        }

        :hover {
            text-decoration: none;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 0.75rem 1rem;
            width: 32.3%;
        }
    `}
`;

export const Panel = styled(animated.div)`
    grid-column: 1/2;
    grid-row: 1/2;
    width: 100%;
`;

export const PanelWrapper = styled.div`
    display: grid;
`;

export const AvatarWrapper = styled.span`
    display: block;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    min-width: 3.5rem;
    width: 3.5rem;
    height: 3.5rem;
    margin-right: 0.6rem;
`;

export const AvatarContainer = styled.span`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        flex-basis: auto;
        max-width: 100%;
        width: 100%;

        @media ${theme.breakpoints.medium.media} {
            margin-bottom: 0.5rem;
        }
    `}
`;

export const BioContainer = styled.span`
    ${({ theme }) => css`
        display: block;
        width: 100%;
        text-align: left;
        width: calc(100% - 4.5rem);

        @media ${theme.breakpoints.medium.media} {
            padding-left: 0.2rem;
            width: calc(100% - 3.5rem);
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1rem;
        }
    `}
`;

export const Position = styled.span`
    ${({ theme }) => css`
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        color: inherit;
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 1.2;

        @media ${theme.breakpoints.medium.media} {
            font-size: inherit;
        }
    `}
`;

export const Label = styled.span<{ $isActive?: boolean }>`
    ${({ theme, $isActive }) => css`
        position: relative;
        text-align: left;
        font-size: 1rem;
        font-family: ${theme.fonts.secondary};
        color: ${$isActive ? theme.colors.accents[10].hex : theme.colors.primaryContrast.hex};

        :hover {
            text-decoration: none;
        }

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.375rem;
        }
    `}
`;

export const Organisation = styled.span`
    ${({ theme }) => css`
        display: block;
        margin: 0;
        text-align: left;
        color: inherit;
        font-size: 0.875rem;
        line-height: 1.2;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: calc(100% - 0.06rem);

        @media ${theme.breakpoints.medium.media} {
            font-size: inherit;
        }
    `}
`;
